// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue"; // 引入 App 组件
import router from "./router";
import Layout from "./components/Layout.vue"; // 引入全局布局组件
import "./assets/styles/global.css"; // 引入全局样式文件

import VueI18n from "vue-i18n";
import en from "./locales/en.json";
import zh from "./locales/zh.json";

// Vue.use(BaiduMap, {
//   ak: 'uqt3QzwPxAYwLFcgSWTCbbqIqCfS5eBm' // 百度地图秘钥
// })
Vue.use(VueI18n);

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: "zh", // 默认语言
  messages: {
    en,
    zh,
  },
});

import axios from "axios";

Vue.use(ElementUI);

Vue.config.productionTip = false;

Vue.prototype.GlobalData = {
  homeUrl:
    "https://fc-mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.next.bspapp.com/utils/getUrls",
  productsUrl:
    "https://fc-mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.next.bspapp.com/utils/getProductsUrls",
  searchProductsUrl:
    "https://fc-mp-a6096c8d-ce7a-456e-969a-9f1913d486a1.next.bspapp.com/utils/queryProducts",

  zongbuPhone: "13823719355",
  zongbuEmail: "zg@dg-asx.com",
  zongbuWeb: "www.asx-probe.com",
  hanguoPhone: "1047183739 ",
  hanguoEmail: "meta198@naver.com",
  shenzhenPhone: "13560788801",
  shenzhenEmail: "13560788801@139.com",

  type_home: 1,
  type_about: 2,
  type_contact: 3,
  type_events: 4,
  type_markets: 5,
  type_product: 6,

  products_pogopin_index: 1,
  pogopin_single_index: 10,
  pogopin_connector_index: 11,
  pogopin_waterproof_index: 12,
  pogopin_magnetic_index: 13,

  products_probes_index: 2,
  probes_ICT_index: 20,
  probes_IC_index: 21,
  probes_hight_current_index: 22,

  products_industry_index: 3,
  industry_plug_socket_index: 30,
  industry_circular_index: 31,
  industry_rectangular_index: 32,

  products_hardware_index: 4,
  hardware_communication_index: 40,
  hardware_medical_index: 41,
  hardware_aerospace_index: 42,
};

Vue.prototype.$axios = axios;

Vue.prototype.GetUrlsByHttp = function (url, type) {
  return new Promise((resolve, reject) => {
    this.$axios
      .get(url + "?getType=" + type)
      .then((res) => {
        console.log("GetUrlsByHttp res : ", res);
        let urls = res.data;
        resolve(urls);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

/* eslint-disable no-new */
new Vue({
  i18n,
  el: "#app",
  router,
  render: (h) => h(Layout), // 使用全局布局组件作为根组件
});



// WEBPACK FOOTER //
// ./src/main.js